import * as React from "react";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";
import { InstantSearch } from "@app/scripts/reactify/instant-search/components/InstantSearch";
import config from "@app/config";
import { createRoot } from "react-dom/client";

document.addEventListener("DOMContentLoaded", () => {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    ...config.reactify,
    mode: "instant-search",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const root = createRoot(ReactifySearchMountNode!);
  
  root.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <Sensors />
        <InstantSearch />
      </ReactifySearchProvider>
    </React.StrictMode>
  );
});